import Gallery from "./Gallery.js";
import GalleryModel from "./GalleryModel.js";
export default {
  id: 'rsrc.dataViewer.GalleryDataViewer',
  type: 'imagineRsrc.Gallery',
  name: 'Gallery',
  icon: 'fa fa-image fa-fw',
  location: ['main'],
  matches: {
    type: 'GroupDataViewer',
    objectType: 'rsrc'
  },
  component: Gallery,
  createSettings: props => {
    return GalleryModel.create();
  }
};